// permissions.js
export function hasFeature(path) {
  // path: "services.addService", "restaurants.editRestaurant", etc.
  const admin = JSON.parse(localStorage.getItem('user') || '{}')
    ?.properties?.[0]?.role === 'admin';
  if (admin) return true;

  try {
    const feats = JSON.parse(localStorage.getItem('allowedFeatures') || '{}');
    return !!path.split('.').reduce((o, k) => (o ? o[k] : undefined), feats);
  } catch {
    return false;
  }
}